/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */
import { type QueryKey } from '@tanstack/react-query';

export function getCertificationPeriodSuggestedFrequenciesAllQueryKey(): QueryKey {
    return ['certification-period-suggested-frequencies'];
}